import { ItemSacola } from '@/types/sacola';

export function construirParametrosParaRequisicaoNovoPedido({
  sacola,
  campo,
}: {
  sacola: ItemSacola[];
  campo: keyof ItemSacola;
}): { id: string }[] {
  return sacola.reduce<{ id: string }[]>((acc, item) => {
    const opcao = item[campo];
    if (opcao && typeof opcao === 'object' && 'id' in opcao) {
      const objetosRepetidos = Array(item.quantidade).fill({ id: opcao.id });
      acc.push(...objetosRepetidos);
    }
    return acc;
  }, []);
}

export function recuperarProdutosFixosCombo(
  sacola: ItemSacola[],
): { id: string }[] {
  return sacola.reduce<{ id: string }[]>((acc, item) => {
    if (item.plano && 'produtos' in item.plano) {
      item.plano.produtos
        .filter((produto) => !produto.variavel)
        .forEach((produtoFixo) => {
          acc.push({ id: produtoFixo.id });
        });
    }
    return acc;
  }, []);
}

export function recuperarCombosIDs(sacola: ItemSacola[]): { id: string }[] {
  return sacola.reduce<{ id: string }[]>((acc, item) => {
    if (item.plano && 'comboID' in item.plano) {
      acc.push({ id: item.plano.comboID });
    }
    return acc;
  }, []);
}
